import { ReactQueryV5 } from "@mindlercare/mindlerapi-client";
const { useQuery } = ReactQueryV5;
import { useMindlerApi } from "api/apiv2";
import { useCalendarSlots } from "components/booking/hooks/useCalendarSlots";
import { Slot, SlotApiRes } from "core/types";
import { useSlotDialogParam } from "hooks/useSlotDialogParam";
import { SlotDialog } from "./slotDialog/slotDialog";

const SlotDialogContainer = ({ slotId }: { slotId: number }) => {
  const api = useMindlerApi();

  const { data: calendarSlots } = useCalendarSlots();
  const calendarSlot = calendarSlots?.find((s) => s.slotId === slotId);

  const { data: fetchedSlot } = useQuery(
    api.slots.getSlotWithPatientInfoBySlotId.queryOptions(
      { slotId },
      {
        enabled: !calendarSlot, // fallback for deep links / slots outside current week.
        select: (raw) =>
          ({
            ...raw,
            startsAt:
              new Date(raw.startsAt as unknown as string).getTime() / 1000,
            endsAt: new Date(raw.endsAt as unknown as string).getTime() / 1000,
            feeWaived: Boolean(raw.feeWaived),
            blocked: Boolean(raw.blocked),
            promoCategory: raw.masterKeyCategory,
            promoTotal: raw.masterKeyQuota,
            promoUsed: raw.ikUsage,
          }) as unknown as SlotApiRes,
      },
    ),
  );

  const slot = calendarSlot ?? fetchedSlot;
  if (!slot) return null;

  return <SlotDialog slot={slot as unknown as Slot} />;
};

const Dialog = () => {
  const [slotId] = useSlotDialogParam();

  if (slotId) return <SlotDialogContainer slotId={slotId} />;
  return null;
};

export default Dialog;
